<template>
  <div>
    <!-- BEGIN: Modal Toggle -->
    <div class="text-center">
      <a
        class="btn btn-primary"
        @click="openEditModal"
      >
        <PlusIcon class="h-3 w-3 mr-1" />
        เพิ่มข่าวประกาศ
      </a>
    </div>
    <ModalLayout v-model="openModalStatus" :headerTitle="`${headTitle}ข่าวประกาศ`" @click:save="saveNews" :isDone="isDone" @click:cancel="clearModal">
        <div>
            <div>
                <label class="form-label">หัวข้อข่าว<span class="text-red"> *</span></label>
                <input id="regular-form-1" type="text" class="form-control" placeholder="หัวข้อข่าว" v-model="validate.title.$model" :class="{ 'border-1 border-theme-24 rounded-md': validate.title.$error}"/>
                <template v-if="validate.title.$error">
                    <div
                        v-for="(error, index) in validate.title.$errors"
                        :key="index"
                        class="text-theme-24 mt-1 text-xs"
                    >
                        {{ error.$message }}
                    </div>
                </template>
            </div>
            <div class="mt-5">
                <label class="form-label">ประเภทข่าว<span class="text-red"> *</span></label>
                <v-select
                    :clearable="false"
                    v-model="validate.category.$model"
                    :searchable="false"
                    :options="['เกี่ยวกับโครงการ','เกี่ยวกับระบบ','ข่าวสาร/ประกาศอื่น']"
                    placeholder="ประเภทข่าว"
                    label="label"
                    :class="{ 'border-1 border-theme-24 rounded-[9px]': validate.category.$error}"
                >
                    <template #open-indicator="{ attributes }">
                        <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
                    </template>
                </v-select>
                <template v-if="validate.category.$error">
                    <div
                        v-for="(error, index) in validate.category.$errors"
                        :key="index"
                        class="text-theme-24 mt-1 text-xs"
                    >
                        {{ error.$message }}
                    </div>
                </template>
            </div>
            <div class="mt-5">
                <label class="form-label">รูปประกอบข่าว</label>
                <FileInput
                    accept-file="image/*"
                    hideDeleteButton
                    v-model="newsForm.image"
                    isPlainInput
                    id="FileImage"
                />
                <div class="relative">
                    <div v-if="newsForm.image||newsForm.imgPreviewUrl" @mouseover="showOrgImg=true" class="mt-1 preview-image" ><img :src="newsForm.imgPreviewUrl"></div>
                    <div v-if="showOrgImg" @mouseleave="showOrgImg=false" class="org-image"><img :src="newsForm.imgPreviewUrl" ></div>
                </div>
            </div>
            <div class="mt-5">
                <label class="form-label">รายละเอียดโดยย่อ</label>
                <textarea placeholder="รายละเอียดโดยย่อ" class="form-control" style="min-height: 60px;resize: none;" v-model="validate.short_detail.$model" :class="{ 'border-1 border-theme-24 rounded-md': validate.short_detail.$error}"/>
                <template v-if="validate.short_detail.$error">
                    <div
                        v-for="(error, index) in validate.short_detail.$errors"
                        :key="index"
                        class="text-theme-24 mt-1 text-xs"
                    >
                        {{ error.$message }}
                    </div>
                </template>
            </div>
            <div class="mt-5" v-if="newsForm.category && newsForm.category != 'ข่าวสาร/ประกาศอื่น'">
                <label class="form-label">อัพโหลดไฟล์</label>
                <FileInput
                    hideDeleteButton
                    v-model="newsForm.attchFile"
                    isPlainInput
                    acceptFile="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, image/*"
                    :class="{ 'border-1 border-theme-24 rounded-md': validate.attchFile.$error}"
                />
                <template v-if="validate.attchFile.$error">
                    <div
                        v-for="(error, index) in validate.attchFile.$errors"
                        :key="index"
                        class="text-theme-24 mt-1 text-xs"
                    >
                        {{ error.$message }}
                    </div>
                </template>
                <div v-if="newsForm.linkPreview" class="mt-1"> <a class="badge-custom bg-theme-6 text-white cursor-pointer font-medium" :href="newsForm.linkPreview" target="_blank">ไฟล์{{newsForm.title}}</a> </div>
            </div>
            <div class="mt-5" v-else>
                <label class="form-label">รายละเอียดข่าว</label>
                <ClassicEditor id="news-editor" :config="configEditor" v-model="validate.detail.$model" :class="{ 'border-1 border-theme-24 rounded-md': validate.detail.$error}"/>
                <template v-if="validate.detail.$error">
                    <div
                        v-for="(error, index) in validate.detail.$errors"
                        :key="index"
                        class="text-theme-24 mt-1 text-xs"
                    >
                        {{ error.$message }}
                    </div>
                </template>
            </div>
        </div>
    </ModalLayout>
  </div>
</template>
<script setup>
import { ref, watch, toRefs } from 'vue'
import ModalLayout from "@/components/base/custom-modal/CustomModalLayout.vue"
import FileInput from "@/components/base/file-input/index.vue";
import { uploadfile, compressImage } from "@/utils/minio.js";
import useVuelidate from '@vuelidate/core'
import { required, helpers, requiredIf, requiredUnless } from '@vuelidate/validators'
import Swal from "sweetalert2"
import axios from 'axios';
import { useStore } from 'vuex';
const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-primary m-1',
    cancelButton: 'btn btn-outline-secondary m-1'
  },
  buttonsStyling: false
})
class MyUploadAdapter {
    constructor( loader ) {
        // The file loader instance to use during the upload.
        this.loader = loader;
    }

    // Starts the upload process.
    upload() {
        return this.loader.file
            .then( file => new Promise( ( resolve, reject ) => {
                this._sendRequest( resolve, reject, file );
            } ) );
    }

    // Prepares the data and sends the request.
    async _sendRequest( resolve, reject, file ) {
        const compress_img =  await compressImage(file)
        const result = await uploadfile(compress_img,'news/images','image')
        if(result.res.status == 200){
            resolve( {
                default: result.url
            } );
        }
        else{
            const genericErrorText = `Couldn't upload file: ${ file.name }.`;
            reject(genericErrorText);
        }

    }
}

function MyCustomUploadAdapterPlugin( editor ) {
    editor.plugins.get( 'FileRepository' ).createUploadAdapter = ( loader ) => {
        // Configure the URL to the upload script in your back-end here!
        return new MyUploadAdapter( loader );
    };
}


const configEditor = ref({
    extraPlugins: [ MyCustomUploadAdapterPlugin ],
    alignment: {
        options: [ 'left', 'right' ]
    },
    placeholder: 'ระบุรายละเอียดข่าว',
    language: 'th',
    mediaEmbed: {
        previewsInData: true
    }
})
const props = defineProps({
    editState: Object
})
const emit = defineEmits(["closeModal", "openModal"])
const cancelData = ref(false)
const openModalStatus = ref(false)
const newsForm = ref({
    title: null,
    category: null,
    short_detail: null,
    detail: '',
    attchFile: null,
    linkPreview: null

})
// const formUpload = ref(false)
// const checkValidate = ref(false)
const isDone = ref(false)
const headTitle = ref("เพิ่ม")
const showOrgImg = ref(false)
const isEdit = ref(false)
const store = useStore()

function cancelModalForm(){
    cancelData.value = true
    openModalStatus.value = false
}
function openEditModal(){
    openModalStatus.value = true
    cancelData.value = false
    emit("openModal")
}
watch(()=> newsForm.value.image, (val)=>{
    if(val){
        const reader = new FileReader()
        reader.readAsDataURL(val)
        reader.onload = () => newsForm.value.imgPreviewUrl = reader.result
        reader.onerror = () => newsForm.value.imgPreviewUrl = null
    }
    else{
        newsForm.value.imgPreviewUrl = null
    }

})
watch(()=> newsForm.value.category, (val,oldValue)=>{
    if(val == "ข่าวสาร/ประกาศอื่น"){
        newsForm.value.attchFile = null
    }
    // if(val === "เกี่ยวกับระบบ" || val === "เกี่ยวกับโครงการ"){
    //     formUpload.value = true
    //     checkValidate.value = true
    // }
    // else{
    //     checkValidate.value = false
    //     formUpload.value = false
    //     newsForm.value.attchFile = null
    // }
})
watch(()=> newsForm.value.image, (val)=>{
    if(val){
        const reader = new FileReader()
        reader.readAsDataURL(val)
        reader.onload = () => newsForm.value.imgPreviewUrl = reader.result
        reader.onerror = () => newsForm.value.imgPreviewUrl = null
    }
    else{
        newsForm.value.imgPreviewUrl = null
    }
})
const rules = {
    title: {
        required: helpers.withMessage(`กรุณาระบุหัวข้อข่าว`, required)
    },
    category: {
        required: helpers.withMessage(`กรุณาเลือกประเภทข่าว`, required)
    },
    short_detail: {
        required: helpers.withMessage(`กรุณาระบุรายละเอียดโดยย่อ`, required)
    },
    detail: {
        required: helpers.withMessage(`กรุณาระบุรายละเอียด`, requiredIf(()=>newsForm.value.category == "ข่าวสาร/ประกาศอื่น"))
    },
    attchFile:{
        required: helpers.withMessage(`กรุณาแนบไฟล์`, requiredIf(()=>(newsForm.value.category != "ข่าวสาร/ประกาศอื่น" && !newsForm.value.linkPreview)))
    }
}
const validate = useVuelidate(rules, newsForm, { $scope: false })
const saveNews = () =>{
    validate.value.$touch()
    if(validate.value.$invalid){
        return ;
    }
    try{
        swalCustom.fire({
            text:"ยืนยันบันทึกข้อมูล",
            icon:"info",
            showCancelButton: true,
            reverseButtons: true,
            confirmButtonText: 'ตกลง',
            cancelButtonText: 'ยกเลิก',
        }).then(async (result)=>{
            if (result.isConfirmed) {
                let uploadImage = true, uploadAttachFile = true
                let data = {
                    TITLE: newsForm.value.title,
                    CATEGORY: newsForm.value.category,
                    SHORT_DETAIL: newsForm.value.short_detail,
                    DETAIL: newsForm.value.detail,
                    STATUS: "NEW"
                }
                if(isEdit.value){
                    data["id"] = newsForm.value.id
                    if(newsForm.value.category === "เกี่ยวกับระบบ" || newsForm.value.category === "เกี่ยวกับโครงการ"){
                        data["DETAIL"] = newsForm.value.linkPreview
                    }
                }
                if(newsForm.value.image){
                    let compress_img =  await compressImage(newsForm.value.image)
                    let result = await uploadfile(compress_img,'news/images','image')
                    if(result.res.status == 200){
                        data["IMAGE_URL"] = result.url
                        uploadImage = true
                    }
                    else{
                        uploadImage = false
                    }
                }
                if(newsForm.value.attchFile){
                    // let compress_img =  await compressImage(newsForm.value.attchFile)
                    let result = await uploadfile(newsForm.value.attchFile,'news/document','file')
                    if(result.res.status == 200){
                        data["DETAIL"] = result.url
                        uploadAttachFile = true
                    }
                    else{
                        uploadAttachFile = false
                    }
                }
                if(uploadImage && uploadAttachFile){
                    const token = store.getters["userAuth/getToken"];
                    const config = {
                        url: `${process.env.VUE_APP_BASE_API}news/${isEdit.value ? data["id"]:''}`,
                        method: `${isEdit.value ? 'PUT' : 'POST'}`,
                        headers:{
                            Authorization: `Bearer ${token}`,
                            "Content-Type": `application/json; charset=utf-8`,
                        },
                        data: isEdit.value ? {update: data}: {doc: data}
                    }
                    const res = await axios(config)
                    .catch(()=>{
                        swalCustom.fire({
                            text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
                            icon: "warning",
                            // timer: 3000, //timeOut for auto-close
                            confirmButtonText: "ปิด",
                        });
                    })
                    if(res){
                        swalCustom.fire({
                        text:"สำเร็จ",
                        icon: 'success',
                        timer: 3000,
                        confirmButtonText: "ปิด",
                        }).then(() => {
                            isDone.value = true
                            clearModal(true)
                        });
                    }
                }
                else{
                    swalCustom.fire({
                        text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
                        icon: "warning",
                        // timer: 3000, //timeOut for auto-close
                        confirmButtonText: "ปิด",
                    });
                }

            }
        })
    }
    catch(err){
        console.log("Error! ",err);
        swalCustom.fire({
            text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
            icon: "warning",
            // timer: 3000, //timeOut for auto-close
            confirmButtonText: "ปิด",
        });
    }
}
function clearModal(isUpdate=null){
    // formUpload.value = false
    // checkValidate.value = false
    newsForm.value.title = null
    newsForm.value.category = null
    newsForm.value.short_detail = null
    newsForm.value.detail = ''
    newsForm.value.attchFile = null
    newsForm.value.linkPreview = null
    newsForm.value.imgPreviewUrl = null
    newsForm.value.image = null
    isDone.value = false
    validate.value.$reset()
    openModalStatus.value = false
    isEdit.value = false
    emit("closeModal",isUpdate)
}

watch(()=>props.editState,(val)=>{
    if(val){
        openModalStatus.value = true
        isEdit.value = true
        newsForm.value.title = props.editState.TITLE
        newsForm.value.category = props.editState.CATEGORY
        newsForm.value.short_detail = props.editState.SHORT_DETAIL
        newsForm.value.detail = props.editState.DETAIL
        newsForm.value.id = props.editState._id
        newsForm.value.imgPreviewUrl = props.editState.IMAGE_URL
        // newsForm.value.attchFile = props.editState.SHORT_DETAIL
        if(props.editState.CATEGORY == "เกี่ยวกับระบบ" || props.editState.CATEGORY == "เกี่ยวกับโครงการ"){
        //   checkValidate.value = true
        //   formUpload.value = true
          newsForm.value.detail = ''
          newsForm.value.linkPreview = props.editState.DETAIL
        }
    }
})

</script>
<style lang="scss">
.ck.ck-tooltip .ck-tooltip__text{
    color: #FFF !important;
}
.ck.ck-editor__editable > .ck-placeholder::before {
    font-style: italic;
    font-weight: 300;
}
.badge-custom{
    display: inline-block;
    padding: 0.25em 0.4em;
    font-size: 75%;
    font-weight: 500;
    line-height: 1;
    color: #fff;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 0.25rem;
}
.preview-image{
    width: 50px;
    height: 50px;
    img{
        width: 100%;
        object-fit: cover;
        height: 100%;
    }
}
.org-image{
    width: auto;
    max-width: 300px;
    position: absolute;
    top: 0;
    z-index: 9;
    img{
        width: 100%;
        height: auto;
    }
}
</style>

